import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=4a8b2412&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=4a8b2412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b2412",
  null
  
)

export default component.exports